/** A short grey hint under a Planner heading or beside a control. */
export const PLANNER_HINT_SX = { fontSize: "0.8125rem", color: "text.secondary", mb: 1.5 } as const;

/** A section heading on a Planner page, e.g. "Who gets it?" or "Events". */
export const PLANNER_SECTION_TITLE_SX = { fontWeight: 600, fontSize: "1rem", mb: 0.5 } as const;

/** Columns of the Planners tab: Name, Audience, Events, Next event, Status, Last updated, chevron. */
export const PLANNER_LIST_COLUMNS =
  "minmax(0, 2.4fr) minmax(0, 1.6fr) minmax(0, 0.8fr) minmax(0, 2fr) minmax(0, 0.9fr) minmax(0, 1.2fr) 32px";

/** Columns of a sent Planner's Events: #, Event, Date, Time, Location, Status, Actions. */
export const SENT_EVENT_COLUMNS =
  "32px minmax(0, 3fr) minmax(0, 1.6fr) minmax(0, 1.1fr) minmax(0, 1.4fr) minmax(0, 1fr) 128px";

/** Columns of the Upcoming tab: Event, Date, Time, Location, chevron. */
export const UPCOMING_EVENT_COLUMNS =
  "minmax(0, 3fr) minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, 1.6fr) 24px";
